import * as React from "react";
import { TextInput, ReferenceArrayInput } from "react-admin";
import Transformer from "../../../common/Transformer";
import { AttributeSetEditComponent } from "./";
import { DualListInput } from "src/enterprise/ra-relationships";
import { Edit, SimpleForm } from "src/enterprise/ra-rbac";
import { Grid } from "@mui/material";

export const AttributeSetEdit = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["id", "createdAt", "updatedAt", "attributeIds"],
      update: {
        attributes: data.attribute_ids,
      },
    });

    return data;
  };

  return (
    <Edit
      component={AttributeSetEditComponent}
      mutationMode="pessimistic"
      transform={transform}
    >
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12} lg={8}>
            <TextInput disabled source="id" />
          </Grid>
          <Grid item sm={12} lg={8}>
            <TextInput source="name" required />
          </Grid>
          <Grid item sm={12} lg={8}>
            <ReferenceArrayInput
              source="attribute_ids"
              reference="admin/product/attributes"
              perPage={999}
            >
              <DualListInput
                label="Attributes"
                optionText="name"
                dense={true}
              />
            </ReferenceArrayInput>
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};
